import React, { useState } from 'react';
import './serviceHeader.css';
import { useDispatch, useSelector } from "react-redux";
import CalendarOffline from "../../CalendarOffline/CalendarOffline";
import { GetServicesThunk } from "../../../redux/thunks/GetServicesThunk";
import { setServicesSettingsAction } from "../../../redux/rootReducer";
import { SERVICES_SETTINGS_INITIAL } from "../../../redux/initialStateConstant";

const ServicesHeader = () => {
    const dispatch = useDispatch();
    const services = useSelector(state => state.services);
    const services_settings = useSelector(state => state.services_settings);

    // Состояние календаря
    const [openFromCalendar, setOpenFromCalendar] = useState(false);

    return (
        <>
            <div className="header--flex">
                <div className={ `services_settings__date ${ services_settings.open ? 'services_settings__date--hidden' : '' }` }>
                    <div className="input input--datepicker"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenFromCalendar(!openFromCalendar);
                         } }
                    >{ services.date ? new Date(services.date).toLocaleDateString('ru-Ru') : '' }</div>
                    <CalendarOffline
                        date={ services.date }
                        handler={ date => {
                            dispatch(GetServicesThunk({ date }));
                            setOpenFromCalendar(false);
                        } }
                        open={ openFromCalendar }
                        close={ () => setOpenFromCalendar(false) }
                    />
                </div>
                <div>
                    {
                        services_settings.open
                        ?
                        <div className="header__btn header__btn--back"
                            onClick={ () => {
                                // Запрашиваем расписание мастера
                                dispatch(GetServicesThunk({
                                    date: services.date
                                }));
                                dispatch(setServicesSettingsAction(SERVICES_SETTINGS_INITIAL));
                            } }
                        >Назад</div>
                        :
                        <div className="header__btn header__btn--settings"
                             onClick={ () => {
                                 dispatch(setServicesSettingsAction({
                                     ...SERVICES_SETTINGS_INITIAL,
                                     open: true
                                 }));
                             } }
                        >Настройки</div>
                    }
                </div>
            </div>
        </>
    );
};

export default ServicesHeader;